import { defineMessages } from 'react-intl'

// fix translations when form is working
// change id structure? to more generic towingOrder structure
export const messages = defineMessages({
  towingOrder: { id: 'forms.towingOrder.towingOrder', defaultMessage: 'id' },
  type: { id: 'towingOrder.type', defaultMessage: 'type' },
  visibility: { id: 'towingOrder.visibility', defaultMessage: 'visibility' },
  vehicleDetails: { id: 'forms.towingOrder.vehicleDetails', defaultMessage: 'vehicle details' },
  registrationNumber: { id: 'forms.towingOrder.vehicleDetails.registrationNumber', defaultMessage: 'reg nro' },
  vehicleClass: { id: 'forms.towingOrder.vehicleDetails.vehicleClass', defaultMessage: 'class' },
  makeAndModel: {
    id: 'forms.towingOrder.vehicleDetails.makeAndModel',
    defaultMessage: 'make and model',
  },
  insuranceCompany: {
    id: 'forms.towingOrder.vehicleDetails.insuranceCompany',
    defaultMessage: 'insurance company',
  },
  owner: { id: 'forms.towingOrder.vehicleDetails.owner', defaultMessage: 'owner' },
  holder: { id: 'forms.towingOrder.vehicleDetails.holder', defaultMessage: 'holder' },

  visibility_open: { id: 'towingOrder.visibility_open', defaultMessage: 'open' },
  visibility_restricted: { id: 'towingOrder.visibility_restricted', defaultMessage: 'restricted' },
  visibility_assigned: { id: 'towingOrder.visibility_assigned', defaultMessage: 'assigned' },
  visibility_subcontract: { id: 'towingOrder.visibility_subcontract', defaultMessage: 'subcontract' },

  status_pending_acceptance: { id: 'towingOrder.status_pending_acceptance', defaultMessage: 'pending acceptance' },
  status_open: { id: 'towingOrder.status_open', defaultMessage: 'open' },
  status_accepted: { id: 'towingOrder.status_accepted', defaultMessage: 'accepted' },
  status_assigned: { id: 'towingOrder.status_assigned', defaultMessage: 'assigned' },
  status_towing_record_created: {
    id: 'towingOrder.status_towing_record_created',
    defaultMessage: 'tow record created',
  },
  status_cancelled: { id: 'towingOrder.status_cancelled', defaultMessage: 'status_cancelled' },

  from: { id: 'towingOrder.from', defaultMessage: 'from' },
  settings_type: { id: 'towingOrder.settings.type', defaultMessage: 'Type' },
  settings_operator: { id: 'towingOrder.settings.operator', defaultMessage: 'Operator' },
  settings_station: { id: 'towingOrder.settings.station', defaultMessage: 'Station' },
  settings_subcontract: { id: 'towingOrder.settings.subcontract', defaultMessage: 'Subcontractor' },
  settings_header: { id: 'towingOrder.settings.header', defaultMessage: 'Order settings' },
  settings_notificationMethod: { id: 'towingOrder.settings.notificationMethod', defaultMessage: 'Seurantalinkki' },
  settings_operatorPlaceholder: { id: 'towingOrder.settings.operatorPlaceholder', defaultMessage: 'Ei osoitettu' },
  settings_notificationMethodPlaceholder: {
    id: 'towingOrder.settings.notificationMethodPlaceholder',
    defaultMessage: 'Älä lähetä',
  },
  scheduling_fixed: { id: 'towingOrder.scheduling_fixed', defaultMessage: 'Fixed schedule' },
  scheduling_flexible: { id: 'towingOrder.scheduling_flexible', defaultMessage: 'Flexible schedule' },
  addTowingOrderSuccessTitle: {
    id: 'towingOrder.add.success.notification.title',
    defaultMessage: 'New towing order added',
  },
  addTowingOrderSuccessMessage: { id: 'towingOrder.add.success.notification.message', defaultMessage: 'Success' },
  editTowingOrderSuccessTitle: {
    id: 'towingOrder.edit.success.notification.title',
    defaultMessage: 'Towing order saved',
  },
  editTowingOrderSuccessMessage: {
    id: 'towingOrder.edit.success.notification.message',
    defaultMessage: 'Changes to towing order has been saved',
  },
  convertToSosOrderSuccessTitle: {
    id: 'towingOrder.convert.success.notification.title',
    defaultMessage: 'Towing order converted',
  },
  convertToSosOrderSuccessMessage: {
    id: 'towingOrder.convert.success.notification.message',
    defaultMessage: 'Changes to towing order has been saved',
  },

  view_statusUpdateModalLabel: { id: 'towingOrder.view.statusUpdateModalLabel', defaultMessage: 'Tilan päivitys' },
  view_lockedTitle: { id: 'towingOrder.view.lockedTitle', defaultMessage: 'Työ lukittu' },
  view_lockedMessage: {
    id: 'towingOrder.view.lockedMessage',
    defaultMessage: '{lockedBy} on avannut työn muokattavaksi.',
  },
  view_navLabel: { id: 'towingOrder.view.navLabel', defaultMessage: 'Työt' },
  view_navEditLabel: { id: 'towingOrder.view.navEditLabel', defaultMessage: 'Muokkaa' },
  view_statusUpdateFailed: {
    id: 'towingOrder.view.statusUpdateFailed',
    defaultMessage: 'Tilan päivitys epäonnistui: {error}',
  },
  view_vehicleDetailsHeader: { id: 'towingOrder.view.vehicleDetailsHeader', defaultMessage: 'Ajoneuvotiedot' },
  view_atjLinkLabel: { id: 'towingOrder.view.atjLinkLabel', defaultMessage: 'ATJ-tiedot' },
  view_customerHeader: { id: 'towingOrder.view.customerHeader', defaultMessage: 'Asiakas' },
  view_toHeader: { id: 'towingOrder.view.toHeader', defaultMessage: 'Mihin' },
  view_repairShopWarning: {
    id: 'towingOrder.view.repairShopWarning',
    defaultMessage: 'Jos työ muuttuu hinaukseksi:',
  },
  view_paymentLinesHeader: { id: 'towingOrder.view.paymentLinesHeader', defaultMessage: 'Maksurivit' },
  view_additionalInfoHeader: { id: 'towingOrder.view.additionalInfoHeader', defaultMessage: 'Lisäselvitykset' },
  view_notesHeader: { id: 'towingOrder.view.notesHeader', defaultMessage: 'Muistiinpanot' },

  statusChangeButtons_approveAndAssignLine1: {
    id: 'towingOrder.statusChangeButtons.approveAndAssignLine1',
    defaultMessage: 'Hyväksy ja',
  },
  statusChangeButtons_approveAndAssignLine2: {
    id: 'towingOrder.statusChangeButtons.approveAndAssignLine2',
    defaultMessage: 'kuittaa itselle',
  },
  statusChangeButtons_approveAndLeaveOpenLine1: {
    id: 'towingOrder.statusChangeButtons.approveAndLeaveOpenLine1',
    defaultMessage: 'Hyväksy ja',
  },
  statusChangeButtons_approveAndLeaveOpenLine2: {
    id: 'towingOrder.statusChangeButtons.approveAndLeaveOpenLine2',
    defaultMessage: 'jätä avoimeksi',
  },
  statusChangeButtons_acceptLabel: {
    id: 'towingOrder.statusChangeButtons.acceptLabel',
    defaultMessage: 'Kuittaa itselle',
  },
  statusChangeButtons_rejectLabel: {
    id: 'towingOrder.statusChangeButtons.rejectLabel',
    defaultMessage: 'Hylkää',
  },
  statusChangeButtons_beginWorkLabel: {
    id: 'towingOrder.statusChangeButtons.beginWorkLabel',
    defaultMessage: 'Aloita työ',
  },
  statusChangeButtons_cancelSosLabel: {
    id: 'towingOrder.statusChangeButtons.cancelSosLabel',
    defaultMessage: 'Peru työ',
  },
  statusChangeButtons_statusUpdatedSuccess: {
    id: 'towingOrder.statusChangeButtons.statusUpdatedSuccess',
    defaultMessage: 'Tila päivitetty onnistuneesti',
  },
  statusChangeButtons_prepaymentModalLabel: {
    id: 'towingOrder.statusChangeButtons.prepaymentModalLabel',
    defaultMessage: 'Ennakkomaksu',
  },
  statusChangeButtons_prepaymentModalMessage: {
    id: 'towingOrder.statusChangeButtons.prepaymentModalMessage',
    defaultMessage: 'Huom! Ennakkomaksua ei ole suoritettu. Haluatko aloittaa työn?',
  },
  statusChangeButtons_prepaymentModalConfirm: {
    id: 'towingOrder.statusChangeButtons.prepaymentModalConfirm',
    defaultMessage: 'Aloita työ',
  },
  statusChangeButtons_prepaymentModalCancel: {
    id: 'towingOrder.statusChangeButtons.prepaymentModalCancel',
    defaultMessage: 'Peruuta',
  },
  statusChangeButtons_delayedStartLabel: {
    id: 'towingOrder.statusChangeButtons.delayedStartLabel',
    defaultMessage: 'Työ aloitettu yli {promptTime} min tilausajankohdasta',
  },
  statusChangeButtons_delayedStartReasonHeader: {
    id: 'towingOrder.statusChangeButtons.delayedStartReasonHeader',
    defaultMessage: 'Anna syy:',
  },

  alTimeChangeModal_reasonHeader: {
    id: 'towingOrder.alTimeChangeModal.reasonHeader',
    defaultMessage: 'Valitse tilausajan muutoksen syy',
  },
  alTimeChangeModal_missingReasonTitle: {
    id: 'towingOrder.alTimeChangeModal.missingReasonTitle',
    defaultMessage: 'Tiedot puutteelliset',
  },
  alTimeChangeModal_missingReasonMessage: {
    id: 'towingOrder.alTimeChangeModal.missingReasonMessage',
    defaultMessage: 'Valitse syy',
  },
  alTimeChangeModal_invalidStartTimeTitle: {
    id: 'towingOrder.alTimeChangeModal.invalidStartTimeTitle',
    defaultMessage: 'Aika virheellinen',
  },
  alTimeChangeModal_invalidTimeFormatMessage: {
    id: 'towingOrder.alTimeChangeModal.invalidTimeFormatMessage',
    defaultMessage: 'Syötä aika muodossa HH:mm',
  },
  alTimeChangeModal_invalidEndTimeTitle: {
    id: 'towingOrder.alTimeChangeModal.invalidEndTimeTitle',
    defaultMessage: 'Aika viimeistään virheellinen',
  },
  alTimeChangeModal_timeLabel: { id: 'towingOrder.alTimeChangeModal.timeLabel', defaultMessage: 'Aika' },
  alTimeChangeModal_startDateLabel: {
    id: 'towingOrder.alTimeChangeModal.startDateLabel',
    defaultMessage: 'Pvm alkaen',
  },
  alTimeChangeModal_endDateLabel: {
    id: 'towingOrder.alTimeChangeModal.endDateLabel',
    defaultMessage: 'Pvm viimeistään',
  },
  alTimeChangeModal_startTimeLabel: {
    id: 'towingOrder.alTimeChangeModal.startTimeLabel',
    defaultMessage: 'Alkaen klo',
  },
  alTimeChangeModal_endTimeLabel: {
    id: 'towingOrder.alTimeChangeModal.endTimeLabel',
    defaultMessage: 'Viimeistään klo',
  },
  alTimeChangeModal_saveButton: {
    id: 'towingOrder.alTimeChangeModal.saveButton',
    defaultMessage: 'Tallenna uusi aika',
  },

  formContents_convertToSosModalMessage: {
    id: 'towingOrder.formContents.convertToSosModalMessage',
    defaultMessage:
      'Täydennä puuttuvat tiedot. Kun kaikki tiedot on täytetty ja painat tallenna, niin tilaus muunnetaan SOS tilaukseksi.',
  },
  formContents_convertToSosLabel: {
    id: 'towingOrder.formContents.convertToSosLabel',
    defaultMessage: 'Muunna SOS tilaukseksi',
  },
  formContents_convertToSosButtonLabel: {
    id: 'towingOrder.formContents.convertToSosButtonLabel',
    defaultMessage: 'Muunna SOS työksi',
  },
  convertToSosOrderModal_title: {
    id: 'towingOrder.convertToSosOrderModal.title',
    defaultMessage: 'Täydennä puuttuvat tiedot',
  },
  formContents_backLabel: {
    id: 'towingOrder.formContents.backLabel',
    defaultMessage: 'Takaisin',
  },
  resendPaymentLinkLabel: {
    id: 'towingOrder.paymentLink.resendLabel',
    defaultMessage: 'Lähetä uudelleen',
  },
  resendPaymentLinkMessage: {
    id: 'towingOrder.paymentLink.resendMessage',
    defaultMessage: 'Haluatko uudelleenlähettää maksulinkin asiakkaalle?',
  },
  resendPaymentLinkSuccessTitle: {
    id: 'towingOrder.paymentLink.resendSuccessTitle',
    defaultMessage: 'Maksulinkki lähetetty uudelleen',
  },
  resendPaymentLinkSuccessMessage: {
    id: 'towingOrder.paymentLink.resendSuccessMessage',
    defaultMessage: 'Maksulinkki on lähetetty uudelleen asiakkaalle.',
  },
  removePaymentLinkLabel: {
    id: 'towingOrder.paymentLink.removeLabel',
    defaultMessage: 'Poista maksulinkki',
  },
  removePaymentLinkMessage: {
    id: 'towingOrder.paymentLink.removeMessage',
    defaultMessage: 'Peruuttaminen avaa maksurivit uudelleen muokattavaksi. Haluatko peruuttaa maksulinkin?',
  },
  removePaymentLinkSuccessTitle: {
    id: 'towingOrder.paymentLink.removeSuccessTitle',
    defaultMessage: 'Maksulinkki peruutettu',
  },
  removePaymentLinkSuccessMessage: {
    id: 'towingOrder.paymentLink.removeSuccessMessage',
    defaultMessage: 'Maksulinkki on peruutettu ja maksurivit ovat jälleen muokattavissa.',
  },
  sendPaymentLinkModalLabel: {
    id: 'towingOrder.paymentLink.sendModalLabel',
    defaultMessage: 'Lähetä maksulinkki',
  },
  sendPaymentLinkModalMessage: {
    id: 'towingOrder.paymentLink.sendModalMessage',
    defaultMessage: 'Maksulinkin lähettäminen lukitsee maksurivit, eikä niitä voi muokata enää. Haluatko jatkaa?',
  },
  sendPaymentLinkModalConfirm: {
    id: 'towingOrder.paymentLink.sendModalConfirm',
    defaultMessage: 'Lähetä',
  },
  paymentLinkMissingReceiptEmail: {
    id: 'towingOrder.paymentLink.missingReceiptEmail',
    defaultMessage: 'Syötä sähköpostiosoite kuittia varten',
  },
  paymentLinkMissingPhone: {
    id: 'towingOrder.paymentLink.missingPhone',
    defaultMessage: 'Syötä puhelinnumero',
  },
  errorNotificationTitle: {
    id: 'towingOrder.errorNotificationTitle',
    defaultMessage: 'Virhe',
  },
  sosOrderMissingFieldsMessage: {
    id: 'towingOrder.sosOrderMissingFieldsMessage',
    defaultMessage: 'Tarkista seuraavat tiedot: {fields}',
  },
  sosOrderMissingLastName: {
    id: 'towingOrder.sosOrderMissingLastName',
    defaultMessage: 'Tilaajan sukunimi puuttuu',
  },
  sosOrderMissingInsuranceCompany: {
    id: 'towingOrder.sosOrderMissingInsuranceCompany',
    defaultMessage: 'Vakuutusyhtiö',
  },
  sosOrderMissingDeliverable: {
    id: 'towingOrder.sosOrderMissingDeliverable',
    defaultMessage: 'Arvioitu toimenpide',
  },
  sosOrderMissingCause: {
    id: 'towingOrder.sosOrderMissingCause',
    defaultMessage: 'Arvioitu vika',
  },
  sosOrderMissingCoordinates: {
    id: 'towingOrder.sosOrderMissingCoordinates',
    defaultMessage: 'Kohteen koordinaatteja ei saatu haettua',
  },
  sosOrderCoordinatesHint: {
    id: 'towingOrder.sosOrderCoordinatesHint',
    defaultMessage: 'Hae osoite kartalta tai valitse osoite osoitehaun ehdotuksista.',
  },
})
